import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import compose from 'recompose/compose';
import { getCurrentUser } from 'shared/graphql/queries/user/getUser';

class CurrentUserComponent extends Component {
  render() {
    const {
      data: { user: currentUser, networkStatus },
      children,
      render,
    } = this.props;
    const isLoading = networkStatus === 1 || networkStatus === 2;

    if (!children && !render) return null;

    return children
      ? children({ currentUser, isLoading })
      : // $FlowIssue
        render({ currentUser, isLoading });
  }
}

export const CurrentUser = compose(getCurrentUser)(CurrentUserComponent);

export const withCurrentUser = Component => {
  const C = props => {
    const { wrappedComponentRef, ...remainingProps } = props;
    return (
      <CurrentUser>
        {({ currentUser, isLoading }) => {
          return (
            <Component
              {...remainingProps}
              currentUser={currentUser ? currentUser : null}
              isloadingcurrentuser={!!isLoading}
              ref={wrappedComponentRef}
            />
          );
        }}
      </CurrentUser>
    );
  };

  C.WrappedComponent = Component;
  return hoistStatics(C, Component);
};
